import ApiInstance from "../utils/instance";

export const GetContact = async (queryParams) => {
    return ApiInstance.get(`/contact?${queryParams}`);
};

export const GetCurpRfc = async (queryParams) => {
    return ApiInstance.get(`/generate_curp_rfc?${queryParams}`);
};

export const UpdateContact = async (params,contactId) => {
    return ApiInstance.put(`/contact/${contactId}`, params);
};

export const CreateContact = async (params) => {
    return ApiInstance.post(`/contact`, params);
};

export const GetPastores = async () => {// Trar por queryParams
    return ApiInstance.get('/pastores');
};

export const GetPastoresData = async (queryParams) => {// Trar por queryParams
    return ApiInstance.get(`/pastores?${queryParams}`);
};

export const GetIglesias = async () => {// Trar por queryParams
    return ApiInstance.get('/iglesias');
};

// Traer por iglesia donde se casó
// LOS OBREROS LLEGAN DIRECTO A CONTACTOS